<template>
  <component :is="layout" />
</template>

<script>
export default {
  name: 'HomeLayout',
  props: {
    component: String
  },

  data () {
    return {
      layout: ''
    }
  },

  computed: {
    loader () {
      return () => import(`@/modules/Home/components/partials/home-${this.$configEmpresa.homeVersion}`)
    }
  },

  created () {
    this.loader().then(() => {
      this.layout = () => this.loader()
    })
  }
}
</script>
